<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.whole_name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { commodityCategoryList } from '../../service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: '',
    departmentID: 0,
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else {
        this.requestDefaultItemCategory()
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.val > 0) {
      this.requestDefaultItemCategory()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        }
      )
    })
  },
  methods: {
    async requestDefaultItemCategory() {
      let res = await commodityCategoryList({ default_id: this.val })
      this.lists = res.data.list
      this.selected = this.val
    },
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          name: query,
          department_id: this.departmentID,
          page: 0,
          size: 20,
        }
        let res = await commodityCategoryList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>